import React, { useState, useEffect } from 'react';
import {
    TextField,
    CircularProgress,
    Typography,
    Link,
    Divider,
} from '@mui/material';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import SingleImageChooser from '../../../fileManager/Components/SingleImageChooser';
import LoadingButton from '../../../../components/elements/LoadingButton';
import axios from 'axios';
import { defaultVariables } from '../../../../../config/index';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import Grid from "@mui/material/Grid2";
import {useTranslation} from "react-i18next";
import SubTitle from "../../../../components/elements/SubTitle";
import RayaField from "../../../../components/elements/fields/RayaField";

const MakeBanner = ({ id, position, model, reload , page}) => {
    const [fields, setFields] = useState({
        link: '',
    });
    const [desktop, setDesktop] = useState(null);
    const [mobile, setMobile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [editMode, setEditMode] = useState(!!id);
    const { t } = useTranslation();

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            loadData();
        } else {
            setLoading(false);
        }
    }, [id]);

    const loadData = async () => {
        const loginToken = localStorage.getItem('ACT');
        if (loginToken) {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            try {
                const response = await axios.get(`${defaultVariables.url}/banners/get/${id}`, config);
                const data = response.data;
                setFields({
                    link: data.link,
                });
                setDesktop(data.desktop_image);
                setMobile(data.mobile_image);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        } else {
            navigate('/login');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleValidation = (callback) => {
        let formIsValid = true;
        const newErrors = {};


        if (!desktop) {
            formIsValid = false;
            newErrors.desktop = t('chooseAFile');
        }

        if (!formIsValid) {
            setErrors(newErrors);
            setSubmitLoading(false);
        }

        callback(formIsValid);
    };

    const handleRequest = async () => {
        const data = new FormData();

        data.append('link', fields?.link || '');
        data.append('desktop_image', desktop?.id || '');
        data.append('mobile_image', mobile?.id || '');
        data.append('position', position);
        if (id) data.append('id', id);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };

        try {
            await axios.post(`${defaultVariables.url}/banners/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            reload();
        } catch (error) {
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            setSubmitLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((isValid) => {
            if (isValid) handleRequest();
        });
    };

    if (loading) {
        return (
            <div style={{ padding: '100px 0', textAlign: 'center' }}>
                <CircularProgress size={35} />
            </div>
        );
    }

    return (
        <div className="modifySinglePricingHolder">
            <Grid container spacing={2} justifyContent="center">
                <Grid item size={12}>
                    <SubTitle align="left">
                        {t('bannerPosition')}: <strong>{page ? t('page_banners') : t(position)}</strong>
                    </SubTitle>
                </Grid>
                <Grid item size={6}>
                    <Typography style={{ textAlign: 'center', marginBottom: 10 }}>{t('bannerImage')}</Typography>
                    <SingleImageChooser primary onChange={setDesktop} initial={desktop} />
                    {errors.desktop && <Typography color="error">{errors.desktop}</Typography>}
                </Grid>
                <Grid item size={6}>
                    <Typography style={{ textAlign: 'center', marginBottom: 10 }}>{t('bannerImageMobile')}</Typography>
                    <SingleImageChooser primary onChange={setMobile} initial={mobile} />
                </Grid>
                <Grid item size={12}>
                    <RayaField
                        fullWidth
                        variant="outlined"
                        label={t('link')}
                        name="link"
                        autoFocus
                        value={fields.link}
                        onChange={handleChange}
                        error={!!errors['link']}
                        helperText={errors['link']}
                        color="violet"
                    />
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        startIcon={<SaveRoundedIcon />}
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        loading={submitLoading}
                    >
                        {t("setDetails")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default MakeBanner;
